import styled from 'styled-components';

import { Box } from 'components/Box';
import { Icon } from 'components/Icon';
import { SimpleTooltip } from 'components/SimpleTooltip';

export const LanguageSelectionMenuTitle = styled(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ({ open, ...props }: any) => (
    <SimpleTooltip
      text={getText('Change Language')}
      offsetBottom={14}
      disabled={open}
      xl
    >
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <div {...props}>
        <Icon name="line-globe" size={18} initialColorName="lightContentGrey" />

        <Box
          position={[null, null, null, open ? 'absolute' : null, 'static']}
          left={32}
          display={[null, null, null, open ? 'inline' : 'none', 'inline']}
          component="span"
          ml="6px"
        >
          {CURRENT_LOCALE.toUpperCase()}
        </Box>
      </div>
    </SimpleTooltip>
  ),
)`
  display: flex;
  align-items: center;
`;
